import Icon from "@repo/ui/components/ui/icon/icon";
import { useBase64QueryState } from "@repo/next-shared/utils/nuqs-custom-parsers";
import { useLocale, useTranslations } from "next-intl";
import { useColors } from "@/data/colors";
import {
  genderBase,
  GenderItem,
  GenderKey,
  getGenderFilter,
} from "@/types/product-search";

type Chip = {
  label: string;
  type:
    | "brand"
    | "gender"
    | "price"
    | "sortByAsc"
    | "sortByDesc"
    | "colorId"
    | "size";
  originalRef?: string;
};

export default function FiltersChips() {
  const t = useTranslations("Products-list.filters");
  const [filters, setFilters] = useBase64QueryState(null, {
    history: "push",
    shallow: false,
  });
  const { data: colors } = useColors();
  const locale = useLocale().substring(0, 2) as keyof GenderItem;

  console.log(filters);
  const getResetFilterObj = (data: Chip) => {
    switch (data.type) {
      case "brand":
        return { brand: filters.brand.filter((b: string) => b !== data.label) };
      case "gender":
        return {
          gender: filters.gender.filter((g: string) => g !== data.originalRef),
        };
      case "price":
        return {
          minPrice: null,
          maxPrice: null,
        };
      case "colorId":
        return {
          colorId: filters.colorId.filter(
            (c: string) => c !== data.originalRef,
          ),
        };
      case "size":
        return {
          size: filters.size.filter((s: string) => s !== data.originalRef),
        };
      case "sortByAsc":
        return { sortByAsc: null };
      case "sortByDesc":
        return { sortByDesc: null };
      default:
        return {};
    }
  };

  const clearSingleFilter = async (data: Chip) => {
    const filter = getResetFilterObj(data);
    await setFilters((prev: any) => ({
      ...prev,
      ...filter,
      pageNumber: 0,
    }));
  };

  const computedChips = [
    ...(filters?.brand
      ? filters?.brand?.map((b: string) => ({
          label: b,
          type: "brand",
        }))
      : []),
    ...(filters?.colorId
      ? filters?.colorId?.map((c: string) => ({
          label: `${t("color")}: ${colors?.find((color) => color.id === c)?.name ?? ""}`,
          type: "colorId",
          originalRef: c,
        }))
      : []),
    ...(filters?.size
      ? filters?.size?.map((s: string) => ({
          label: `${t("size")}: ${s}`,
          type: "size",
          originalRef: s,
        }))
      : []),
    ...(filters?.gender
      ? filters?.gender?.map((g: GenderKey) => ({
          label: `${t("gender")}: ${getGenderFilter(locale, g)}`,
          type: "gender",
          originalRef: g,
        }))
      : []),
    ...(!!filters &&
    filters?.minPrice !== null &&
    filters?.maxPrice !== null &&
    filters?.minPrice !== undefined &&
    filters?.maxPrice !== undefined
      ? [
          {
            label: `${filters.minPrice}€ - ${filters.maxPrice}€`,
            type: "price",
          },
        ]
      : []),
    ...(filters?.sortByAsc
      ? [
          {
            label: `${t("order")}: ${t("order-asc")}`,
            type: "sortByAsc",
          },
        ]
      : []),
    ...(filters?.sortByDesc
      ? [
          {
            label: `${t("order")}: ${t("order-desc")}`,
            type: "sortByDesc",
          },
        ]
      : []),
  ];

  if (computedChips.length > 0) {
    return (
      <section className="flex flex-wrap gap-2 mt-6 mb-10 max-md:text-[14px] font-bold">
        {computedChips.map((cp: Chip, index: number) => (
          <div
            key={`${cp.label}-${index}`}
            className="rounded-[20px] bg-secondary-gray1 dark:bg-secondary-gray4 py-2 px-4 flex items-center gap-2"
          >
            {cp.label}
            <Icon
              onClick={() => clearSingleFilter(cp)}
              icon="Close"
              className="h-[20px] w-[20px]"
            />
          </div>
        ))}
      </section>
    );
  }
}
